/*eslint complexity: ["error", 23]*/
import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { CreateUpdateCompanyDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import { TemplateTypeEnum } from '../../../common/pokCore/validation/enums';
import DynamicTextarea from '../../../app/components/DynamicTextarea';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface CompanyBasicDataTabProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  personalLanguageOptions: Array<{ value: string; label: string }>;
  selectedLanguage: Array<{ value: string; label: string }>;
  templateTypeOptions: Array<{ value: TemplateTypeEnum; label: string }>;
  setFile: (logo: string) => void;
}

export const CompanyBasicDataTab: React.FC<CompanyBasicDataTabProps> = ({
  company,
  propertyChange,
  personalLanguageOptions,
  selectedLanguage,
  templateTypeOptions,
}) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="name" label={t(tk.common.name)}>
        <Form.Control
          type="text"
          value={company?.name || ''}
          onChange={e => propertyChange({ name: e.target.value })}
        />
      </FormRow>

      <FormRow controlId="shortname" label={t(tk.common.shortname)}>
        <Form.Control
          type="text"
          value={company?.shortname || ''}
          onChange={e => propertyChange({ shortname: e.target.value })}
        />
      </FormRow>

      <FormRow
        controlId="personalLanguage"
        label={t(tk.administration.personalLanguage)}
      >
        <Select
          options={personalLanguageOptions}
          value={selectedLanguage}
          onChange={options =>
            propertyChange({ personalLanguage: options?.value })
          }
          placeholder={t(tk.component.pointOut)}
        />
      </FormRow>
      <FormRow
        controlId="applicationType"
        label={t(tk.administration.invoiceTemplate)}
      >
        <Select
          value={
            company?.templateType
              ? templateTypeOptions.find(
                  ({ value }) => company?.templateType === value,
                )
              : null
          }
          options={templateTypeOptions}
          onChange={option =>
            propertyChange({
              templateType: option?.value,
            })
          }
          placeholder={t(tk.component.pointOut)}
        />
      </FormRow>
      <FormRow controlId="delay" label={t(tk.prLang.maxDelay)}>
        <Form.Control
          type="number"
          min={0}
          value={company?.projectMaxDaysDelay ?? ''}
          onChange={e =>
            propertyChange({
              projectMaxDaysDelay: parseInt(e.target.value, 10),
            })
          }
        />
      </FormRow>

      <FormRow controlId="order" label={t(tk.administration.noFull)}>
        <Form.Control
          type="number"
          min={0}
          value={company?.orderField ?? ''}
          onChange={e =>
            propertyChange({
              orderField: parseInt(e.target.value, 10),
            })
          }
        />
      </FormRow>
      <FormRow
        controlId="invoicesEmail"
        label={t(tk.administration.emailInvoice)}
      >
        <Form.Control
          type="text"
          value={company?.invoicesEmail || ''}
          onChange={e => propertyChange({ invoicesEmail: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="footer" label={t(tk.administration.footer)}>
        <DynamicTextarea
          onChange={e => propertyChange({ footer: e.target.value })}
          value={company?.footer || ''}
        />
      </FormRow>
      <FormRow
        controlId="footerInEnglish"
        label={t(tk.administration.footerEn)}
      >
        <DynamicTextarea
          onChange={e => propertyChange({ footerInEnglish: e.target.value })}
          value={company?.footerInEnglish || ''}
        />
      </FormRow>
      <FormRow controlId="active" label={t(tk.common.activeShe)}>
        <Form.Check
          type="checkbox"
          className="pt-2"
          checked={
            company?.active ||
            company?.active === undefined ||
            company?.active === null
              ? true
              : false
          }
          onChange={e => propertyChange({ active: e.target.checked })}
        />
      </FormRow>
    </Form>
  );
};
